export default "assets/images/logo-white-d40d32b4.png";